import { Route, NavigationGuardNext } from "vue-router";

import { DIContainer } from "@/app.container";

export default async function customerPreviewGuard(
  to: Route,
  from: Route,
  next: NavigationGuardNext
): Promise<void> {
  const availabilityChecker = DIContainer.CustomerPreviewAvailabilityChecker;

  const plushieId = to.query.plushieId.toString();

  try {
    await availabilityChecker.check(plushieId);
  } catch (e) {
    return next({ name: "PreviewUnavailablePage", query: { plushieId } });
  }

  next();
}
